import PropTypes from 'prop-types';

export const ButtonInterface = PropTypes.shape({
  onClick: PropTypes.func,
  btnText: PropTypes.string
});
